<template>
  <v-card>
    <v-toolbar flat dense class="card-bar" v-if="item != null">
      <v-toolbar-title>
        <span v-if="item.org == null">
          Mailbox #{{ item.id }} ({{ item.label }})
        </span>
        <span v-else> Compilado atual em {{ item.org.name }} </span>
      </v-toolbar-title>
      <v-btn icon small class="ml-2" @click="reload">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <v-dialog
      content-class="dialog-fixed-top"
      v-model="showingDialog"
      max-width="700"
    >
      <v-card>
        <v-card-text class="pa-6">
          <pre>{{ dialogContents }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card-text v-if="item != null">
      <div class="d-flex">
        <span class="grey--text text-right mr-2" style="width: 100px"
          >Criado</span
        >
        <span>{{ item.createdAt | moment }}</span>
      </div>
      <div class="d-flex">
        <span class="grey--text text-right mr-2" style="width: 100px"
          >Entregue</span
        >
        <span>{{ item.deliveredAt | moment }}</span>
      </div>
      <div class="d-flex">
        <span class="grey--text text-right mr-2" style="width: 100px"
          >Cancelado</span
        >
        <span>{{ item.deletedAt | moment }}</span>
      </div>
    </v-card-text>

    <ODataTable
      v-if="spec != null"
      class="dense-table"
      :spec="spec"
      :items="filteredRows"
      @rowClicked="showDialog"
    />
  </v-card>
</template>

<script>
import OLoadingLine from 'oderon-vue/cpts/OLoadingLine'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import { MailboxItem, OrgApi } from '@/models'

let color = 'grey--text text--lighten-1',
  grey = x => ({ html: `<span class="${color}">${x}</span>` })

export default {
  components: {
    OLoadingLine,
    ODataTable
  },
  props: {
    item: {},
    keywords: { type: String }
  },
  watch: {
    item() {
      this.reload()
    }
  },
  data() {
    return {
      isLoading: false,
      rows: [],

      showingDialog: false,
      dialogContents: null,

      specDrivers: [
        { t: 'Pos.|', d: 'index', f: grey },
        { t: 'ID|', d: 'id' },
        { t: 'Nome', d: 'name' },
        { t: 'Crachá', d: 'code' },
        { t: 'Expira', d: 'expiresAt' }
      ],

      specEis: [
        { t: 'Pos.|', d: '$index', f: grey },
        { t: 'ID|', d: 'id' },
        { t: 'Nome', d: 'name' }
      ],

      specPolygons: [
        { t: 'Pos.|', d: '$index', f: grey },
        { t: 'ID|', d: 'id' },
        { t: 'Nome', d: 'name' }
      ]
    }
  },
  computed: {
    spec() {
      if (this.item == null) return null
      if (this.item.information == 'driverSet') return this.specDrivers
      if (this.item.information == 'embeddedRulesSet') return this.specEis
      if (this.item.information == 'polygonSet') return this.specPolygons
      return null
    },

    filteredRows() {
      if (this.keywords == null) return this.rows
      return this.rows.filter(row => {
        return JSON.stringify(row)
          .toLowerCase()
          .includes(this.keywords.toLowerCase())
      })
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      if (this.item == null) return null
      if (this.item.org != null) {
        await this.fetchCompiledInOrg(this.item)
      } else {
        await this.fetchMailbox(this.item.id)
      }
    },

    async fetchMailbox(mailboxId) {
      let res = await MailboxItem.findById(mailboxId)

      if (res.information == 'driverSet') {
        this.rows = mergeCardsAndDrivers(res.originJson)
      } else {
        this.rows = res.originJson
      }
    },

    async fetchCompiledInOrg({ org, vehicleId, information }) {
      let fetcher = new OrgApi(org),
        res = await fetcher.get(`/vehicles/${vehicleId}/compiled-mailboxes`)

      if (information == 'driverSet') {
        this.rows = mergeCardsAndDrivers(res)
      } else if (information == 'embeddedRulesSet') {
        this.rows = res.eis
      } else if (information == 'polygonSet') {
        this.rows = res.polygons
      }
    },

    showDialog(item) {
      this.dialogContents = JSON.stringify(item, null, ' ')
      this.showingDialog = true
    }
  }
}

function mergeCardsAndDrivers(originJson) {
  let result = []
  if (originJson.drivers) {
    originJson.drivers.forEach((d, i) => {
      d.index = i
      result.push(d)
    })
  }

  if (originJson.cards) {
    originJson.cards.forEach((c, i) => {
      c.index = i
      result.push(c)
    })
  }

  return result
}
</script>

<style></style>
